import { Bugfender } from '@bugfender/sdk'

import { BUGFENDER_OPTIONS, bootBugfender } from '@utils/bugfender-boot'
import { crashReporter } from '@utils/crash-reporter'

// The first statement of main's own code (main.ts imports it first): a failure in any module evaluated after it
// is reported. The shared chunks main imports (Angular, Firebase, the SDK, code also used by lazy pages) are
// evaluated before it, so a failure there still reaches nobody.
bootBugfender(Bugfender, window, BUGFENDER_OPTIONS, crashReporter)
